import Vue from 'vue'
import App from './App.vue'
import store from './store'
import '@/core/lazy'
import '@/styles/index.less'
import { previewImage } from '@/utils/previewImage.js';

import Helper from '@/utils/helper'

Helper(Vue)

Vue.config.productionTip = false
Vue.prototype.$previewImage = previewImage;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

document.title = process.env.VUE_APP_DOCUMENT_TITLE || '智能问答平台'
